import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Countdown from "react-countdown";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import flag from "../../../assets/images/Auditions/flag.png";
import flag4 from "../../../assets/images/Interval-01.1.png";
import flag2 from "../../../assets/images/Maximum-Time-01.1.png";
import vector from "../../../assets/images/meetupEvent/Vector.png";
import flag3 from "../../../assets/images/Minimum-Time-01.1.png";
import flag1 from "../../../assets/images/Registration-End-01.1.png";
import ContdownTimerRender from "../../../HelperComponent/ContdownTimerRender";

const LiveChatDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [slot, setSlot] = useState([]);
  const [event, setEvent] = useState([]);
  const [myInfo, setMyInfo] = useState({});
  const [eventTime, setEventTime] = useState('');

  useEffect(() => {
    const event_id = props.match.params.id;

    axios.get(`/api/star/live-chat/details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setEventTime(res.data.event?.event_date);
      }
    });

    axios
      .get(`/api/star/live-chat/registered_user_list/${event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSlot(res.data.users);
        }
      });

    axios.get(`/api/user_info`).then((res) => {
      if (res.data.status === 200) {
        setMyInfo(res.data.users);
      }
    });
  }, [props.match.params.slug, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/live-chat/setApprove/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/live-chat/approved");
        }
      });
    });
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/live-chat/setReject/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Warning", res.data.message, "warning");
          history.push("/superstar/live-chat/rejected");
        }
      });
    });
  };

  const joinRoute = () => {
    history.push({
      // pathname: `/superstar/live-chat/stream/${event.slug}`,
      pathname: `/superstar/callDetails`,
      // search: `id=${event.slug}`
      state: { event_id: event.id, slot: slot, from: "star" },
    });
  };

  // new countdown
  // const auctionTime = moment(eventTime).format('LL HH:mm:ss')
  const startTime = moment(eventTime).format("LL") + " " + event.start_time;

  const event_start = new Date(
    moment(eventTime).format("LL") + " " + event.start_time
  ).getTime();

  const event_end = new Date(
    moment(eventTime).format("LL") + " " + event.end_time
  ).getTime();

  const countDownDate = new Date(startTime).getTime();


  return (
    <>
      <div className="container-fluid">
          <>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
                <div className="card card-bg p-3 mb-3">
                  <img
                    src={imageCdnUrl + event.banner}
                    alt=""
                    className="Banner-SME-b"
                  />
                  <Countdown
                    date={startTime}
                    renderer={ContdownTimerRender} />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 col-lg-6 m-0  mb-3">
                <div className="registration-head  card-bg mb-1">
                  <h5 className="text-warning fw-bold p-2">Registration </h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Start:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag1} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration End:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag2} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Maximum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.max_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag3} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Minimum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.min_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Interval:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.interval} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Fee:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.fee} $
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>

        <div className="row mt-1">
          <div className="col-md-12">
            <div className="card card-bg shadow">
              <div className="card-body">
                <h5 className="text-light pb-3">{event.title}</h5>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.description} />
                </p>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.instruction} />
                </p>

                <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                  <h5 className="text-warning pt-2 ">Event Date</h5>
                  <p className="text-light fw-bold pt-2">
                    {moment(event.event_date).format("LL")} |{" "}
                    {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                    {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-md-12">
            <div className="card card-bg solt-card">
              <div className="card-body">
                <h3 className="text-warning">
                  <img src={vector} alt="clock" className="mx-2"></img>
                  Registered Users ({slot.length})
                </h3>
                <div className="row my-3">
                  {slot.map((user, index) => (
                    <div className="col-md-2 col-sm-3 ">
                      <p className="sold-small-card fw-bold text-ellipsis">
                        <img
                          src={imageCdnUrl + user.user?.image}
                          className="img-fluid mx-2 p-1"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        {user.user?.first_name} {user.user?.last_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {Number(event.status) === 2 &&
              event_start <= new Date().getTime() &&
              event_end > new Date().getTime() ? (
              <div className="my-5 col-md-2 mx-auto">
                <button
                  className="btn btnJoinNow w-100 fw-bold "
                  onClick={joinRoute}
                >
                  Join Now
                </button>
              </div>
            ) : Number(event.status) === 2 &&
              event_end < new Date().getTime() ? (
              <div className="my-5 col-md-2 mx-auto">
                <button
                  className="btn btnDecline 
                   MEN-X fw-bold "
                  disabled
                >
                  Event End
                </button>
              </div>
            ) : Number(event.status) < 2 ? (
              <div className="my-5 row">
                {Number(event.status) < 1 && (
                  <>
                    <div className=" col-md-2 my-2">
                      <button
                        className="btn btnConfirm w-100 fw-bold px-3"
                        onClick={handleClick}
                      >
                        Approved
                      </button>
                    </div>
                    <div className="col-md-2 my-2">
                      <button
                        className="btn btnDecline w-100 px-4 text-dark fw-bold"
                        onClick={setReject}
                      >
                        Reject
                      </button>
                    </div>
                  </>
                )}

                <div className="col-md-2 my-2">
                  <Link to={`/superstar/live-chat/edit/${event.id}`}>
                    <button className="btn btnEdit w-100 fw-bold ">Edit</button>
                  </Link>
                </div>
              </div>
            ) : Number(event.status) === 9 ? (
              <></>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default LiveChatDetails;
